import React from 'react';
import 'assets/styles/components/_react-tostify.scss';
import { ToastContainer } from 'react-toastify';

const ToastNotify = () => {
  return <ToastContainer autoClose={5000} />;
};

export default ToastNotify;
